import { render } from "./Footer.vue?vue&type=template&id=45c98b69&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=45c98b69&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-云南农业大学-前台页面/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c98b69"]])

export default __exports__